import { render, staticRenderFns } from "./EditAddressSection.vue?vue&type=template&id=0d5ab0b7"
import script from "./EditAddressSection.vue?vue&type=script&lang=ts"
export * from "./EditAddressSection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports